import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, setSVAListSuccess, setSVAListFailure } from './actions';
import { cards } from '../../../helpers/api';

export function* setSVAList() {
  try {
    const data = yield call(cards.getSVA);
    yield put(setSVAListSuccess(data?.result?.produtosSVA));
  } catch (e) {
    const errorMessages = { messages: e?.messages };
    yield put(setSVAListFailure(errorMessages));
  }
}

export default all([takeLatest(Types.REQUEST, setSVAList)]);
